import { createClient } from '@supabase/supabase-js';
import { env } from '../config/environment';

export const supabase = createClient(env.supabase.url, env.supabase.anonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});